<template>
  <div class="device">
    <!-- 头部区域 -->
    <div class="header">
      <!-- 引用header组件 -->
      <Header class="head"></Header>
      <!-- 内容区域 -->
      <div class="header-content">
        <div class="banner-content">
          <!-- 标题 -->
          <div class="banner-first-title">
            智能设备终端全打通可视化运营
          </div>
          <!-- 副标题 -->
          <div class="banner-second-title">
            {{ bannerSecond }}
          </div>
          <!-- 申请试用 -->
          <Apply :inputName="tit" :type="type" class="applybtn"></Apply>
        </div>
        <!-- 图片,用作flex占位 -->
        <div class="banner-img"></div>
      </div>
    </div>
    <!-- 正文 -->
    <div class="content">
      <!-- 视频区域 -->
      <div class="video-content">
        <!-- 标题 -->
        <div class="product-title">
          <!-- 图片 -->
          <div class="product-title-img">
            <img src="../assets/img/device/device.png" alt="" />
          </div>
        </div>
        <!-- 左侧视频 -->
        <Video :mp="mp" :poster="poster" class="video"></Video>
      </div>
      <!-- 产品内容 -->
      <div class="product-content">
        <!-- for循环productList -->
        <div class="item" v-for="(item, index) in productList" :key="index">
          <!-- 图片 -->
          <div class="img2">
            <img :src="item.img" alt="" />
          </div>
          <div class="detail">
            <!-- 标题 -->
            <div class="title2">
              <img :src="item.name" alt="" />
              <div class="intro">
                {{ item.intro }}
              </div>
            </div>
            <!-- 功能 -->
            <div class="func">
              <div class="func-detail">
                <div
                  class="func-item"
                  v-for="(item2, index2) in item.children"
                  :key="index2"
                >
                  <div class="func-name">
                    {{ item2 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务 -->
    <Serve></Serve>
    <!-- 解决方案 -->
    <Solution :inputName="apply" :type="type"></Solution>
  </div>
</template>

<script>
// 引用申请试用和头部组件
import Apply from '../components/apply.vue'
import Header from '../components/header.vue'
import Serve from '../components/serve.vue'
import Solution from '../components/solution.vue'
import Video from '../components/video.vue'
export default {
  components: {
    Apply,
    Header,
    Serve,
    Solution,
    Video
  },
  data() {
    return {
      bannerSecond:
        '利用先进的信息化手段，在实现关注食品安全，保护消费者权益、方便消费购物的同时，提升市场管理水平，实现菜市场运营管理、网上菜场、市场监管等三大平台功能，海量异构数据统一分析处理与展示。',
      tit: '联系我们',
      apply: '智慧农贸解决方案',
      // 产品内容
      productList: [
        {
          name: require('../assets/img/device/011.png'),
          intro:
            '实现智能称重、收银，可打印溯源票据，此外，还搭载智能AI识别功能快速识别秤盘上的商品，便于商户操作。',
          img: require('../assets/img/device/01.png'),
          children: ['食品溯源', '智能识别', '打印小票', '数据采集']
        },
        {
          name: require('../assets/img/device/022.png'),
          intro:
            '商家信息公示屏幕，包含商户信息卫生许可证、健康证、营业执照，今日菜价等信息，便于顾客查看实时情况。',
          img: require('../assets/img/device/02.png'),
          children: ['商户信息', '明码标价', '智慧支付', '亮证经营']
        },
        {
          name: require('../assets/img/device/033.png'),
          intro:
            '农贸市场自主导购查询屏，用户可查看该市场的介绍、地图、平均菜价以及当日的食品安全检测。',
          img: require('../assets/img/device/03.png'),
          children: ['市场介绍', '市场地图', '食安检测', '指导菜价']
        },
        {
          name: require('../assets/img/device/044.png'),
          intro:
            '可通过大数据信息展示屏了解该市场信息、今日抽检的合格率、抽检结果，以及该市场的空气质量。',
          img: require('../assets/img/device/04.png'),
          children: ['市场信息', '抽检公示', '空气质量', '市场客流']
        },
        {
          name: require('../assets/img/device/055.png'),
          intro:
            '农贸市场自主导购查询屏，用户可查看该市场的介绍、地图、平均菜价以及当日的食品安全检测。',
          img: require('../assets/img/device/05.png'),
          children: ['客流统计']
        },
        {
          name: require('../assets/img/device/066.png'),
          intro:
            '可通过大数据信息展示屏了解该市场信息、今日抽检的合格率、抽检结果，以及该市场的空气质量。',
          img: require('../assets/img/device/06.png'),
          children: ['食品检测', '抽检公示']
        }
      ],
      mp:
        'https://file.agricultural.fameveg.com/file/upload/null/2021-07-22/2cbd4318d87b4a4a804e2cc049d82aa8.mp4',
      poster:
        'https://file.agricultural.fameveg.com/file/upload/null/2021-07-22/b4bc72ef613442dd91ea5d828a365072.png',
      type: '2'
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.device {
  height: 100%;
}
// 头部区域
.header {
  height: 800px;
  width: 100%;
  background: url(../assets/img/device/banner.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  color: #fff;
  font-size: 22px;
  .header-content {
    display: flex;
    justify-content: center;
    .banner-content {
      width: 800px;
      color: #ffffff;
      padding: 43px;
      .banner-first-title {
        margin-top: 70px;
        font-size: 50px;
      }
      .banner-second-title {
        margin-top: 50px;
        font-size: 22px;
        margin-bottom: 60px;
        width: 500px;
      }
      .applybtn {
        position: relative;
        top: 50px;
        left: -150px;
      }
    }
    .banner-img {
      width: 600px;
    }
  }
}
.content {
  .video-content {
    margin-top: 100px;
    .product-title {
      width: 191px;
      margin: 0 auto;
    }
    .video {
      width: 900px;
      margin: 100px auto;
    }
  }

  // 产品内容
  .product-content {
    .item {
      // 左右布局，偶数的item，使用flex-end布局
      display: flex;
      height: 650px;
      justify-content: center;
      .img2 {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .detail {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 800px;
        margin: 0 20px;
        .title2 {
          display: flex;
          flex-direction: column;
          img {
            margin-left: 20px;
            width: 435px;
          }
          .intro {
            margin-top: 27px;
            color: #999999;
            font-size: 20px;
          }
        }
        .func {
          .func-detail {
            display: flex;
            flex-wrap: wrap;
            .func-item {
              display: flex;
              color: #999999;
              font-size: 20px;
              width: 130px;
              height: 130px;
              border: 1px solid #d1d1d1;
              border-radius: 50%;
              align-items: center;
              justify-content: center;
              margin: 0 20px;
              cursor: default;
            }
            .func-item:hover {
              background-color: #ff8f11;
              color: #fff;
              font-size: 22px;
            }
          }
        }
      }
    }
    .item:nth-child(2n) {
      flex-direction: row-reverse;
      background-color: #f5f5f5;
    }
    .item:nth-child(2) {
      .title2 {
        img {
          width: 344px !important;
        }
      }
    }
    .item:nth-child(3),
    .item:nth-child(4),
    .item:nth-child(5) {
      .title2 {
        img {
          width: 338px !important;
        }
      }
    }
    .item:nth-child(6) {
      .title2 {
        img {
          width: 356px !important;
        }
      }
    }
  }
}
</style>
